/* unplugin-vue-components disabled */import TasksRunner from 'components/tasks-runner'
import {waitForEvent} from 'utils/dom'


import {API_TASKS} from 'consts/api'

const __default__ = {
  props: {
    tenant: {type: Object, required: true}
  },
  methods: {
    async runImportProductsCsv(tasks) {
      let input = this.$refs.file_input

      input.value = null
      input.click()
      await waitForEvent(input, 'change')

      if (!input.value) {
        return undefined
      }

      const file = input.files[0]
      if (!file.name.toLowerCase().endsWith('.csv')) {
        $utils.toasts.error('Please select a .csv file')
        return undefined
      }

      return await tasks.start(`${API_TASKS}/import/products?tenant_id=${this.tenant.id}`, file, {fileData: true})
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'tenant-products',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get API_TASKS() { return API_TASKS }, get TasksRunner() { return TasksRunner }, get waitForEvent() { return waitForEvent } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})